/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormQualitySection } from '../../models/form-quality-section';
import { FormQualitySectionDto } from '../../models/form-quality-section-dto';

export interface UpdateFormQualitySection$Params {
  formId: string;
  body: FormQualitySectionDto;
}

export function updateFormQualitySection(
  http: HttpClient,
  rootUrl: string,
  params: UpdateFormQualitySection$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormQualitySection>> {
  const rb = new RequestBuilder(rootUrl, updateFormQualitySection.PATH, 'put');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormQualitySection>;
    })
  );
}

updateFormQualitySection.PATH = '/forms/{formId}/quality-section';
